import { TableHistoryActions } from 'src/store/actions/tableHistoryActions';
import defaultDisplayConfig from 'src/containers/Reports/TableHistory/Content/defaultDisplayConfig.json';
const initialState = {
    paginationData: null,
    list: [],
    loading: false,
    cacheId: undefined,
    displayConfig: defaultDisplayConfig
};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case TableHistoryActions.GET_TABLE_HISTORY_REQUEST: {
            return ({
                ...state,
                loading: true
            });
        }
        case TableHistoryActions.GET_TABLE_HISTORY_SUCCESS: {
            return ({
                ...state,
                loading: false,
                list: payload?.Data || [],
                paginationData: payload?.Pagination || null,
                cacheId: payload?.CacheId
            });
        }
        case TableHistoryActions.GET_TABLE_HISTORY_FAIL: {
            return ({
                ...state,
                loading: false
            });
        }
        case TableHistoryActions.GET_TABLE_HISTORY_CONFIG_SUCCESS: {
            return ({
                ...state,
                displayConfig: payload
            });
        }
        default: return state;
    }
};
